module.exports = __webpack_public_path__ + "img/crFTD_Regs.82345a31.svg";